import classNames from 'classnames';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import buttonStyles from '../Button/Button.module.css';
import { ButtonVariants } from '../Button/Button.types';
import LoadingSpinner from '../Button/LoadingSpinner/LoadingSpinner';
import styles from './ButtonLink.module.css';
import { ButtonProps } from './ButtonLink.types';

/**
 * the same styles as the button component but using an Link component from react router
 */
const ButtonLink: FC<ButtonProps> = ({
  variant = ButtonVariants.Primary,
  label,
  children,
  className,
  isLoading,
  loadingLabel,
  ...props
}) => {
  const text = isLoading && loadingLabel !== undefined ? loadingLabel : children || label;
  return (
    <Link
      className={classNames({
        [styles.buttonLink]: variant !== ButtonVariants.Text,
        [buttonStyles.button]: variant !== ButtonVariants.Text,
        [buttonStyles.primary]: variant === ButtonVariants.Primary,
        [buttonStyles.secondary]: variant === ButtonVariants.Secondary,
        [buttonStyles.textbutton]: variant === ButtonVariants.Text,
        [buttonStyles.loadingButton]: isLoading,
        [className!]: className !== undefined,
      })}
      {...props}
    >
      {text}
      {isLoading === true && (
        <LoadingSpinner
          variant={variant === ButtonVariants.Primary ? ButtonVariants.Primary : ButtonVariants.Secondary}
          className={buttonStyles.loadingIcon}
        />
      )}
    </Link>
  );
};

export default ButtonLink;
